module.exports = __webpack_public_path__ + "static/media/playspace_section4_mobile.472e0b22.png";